import { create } from "zustand";
import { devtools } from "zustand/middleware";
import { immer } from "zustand/middleware/immer";

import { isProductionEnvironment } from "utils/env";

import { DEFAULT_GROUP_META } from "./constants";
import { PersonalSettingsSpacesTableGroupsStore } from "./types";
import { PersonalSettingsSpacesTableGroupMeta } from "./types";
import { SpaceActionsGroup } from "../../types";

const usePersonalSettingsSpacesTableGroupsStore = create<PersonalSettingsSpacesTableGroupsStore>()(
  devtools(
    immer((set) => ({
      groups: [],
      groupsMeta: {},
      initializeStore: (spaceActions: SpaceActionsGroup[]) =>
        set((state) => {
          state.groups = spaceActions;
          state.groupsMeta = spaceActions.reduce(
            (acc, spaceAction) => {
              return { ...acc, [spaceAction.spaceID]: { isOpen: false } };
            },
            {} as Record<string, PersonalSettingsSpacesTableGroupMeta>
          );
        }),
      toggleGroupMeta: (groupId) =>
        set((state) => {
          const groupMeta = state.groupsMeta[groupId] || DEFAULT_GROUP_META;
          state.groupsMeta[groupId] = {
            ...groupMeta,
            isOpen: !groupMeta.isOpen,
          };
        }),
      openGroup: (groupId) =>
        set((state) => {
          const groupMeta = state.groupsMeta[groupId] || DEFAULT_GROUP_META;
          state.groupsMeta[groupId] = {
            ...groupMeta,
            isOpen: true,
          };
        }),
    })),
    {
      enabled: !isProductionEnvironment(),
    }
  )
);

export default usePersonalSettingsSpacesTableGroupsStore;
